<script>
import find from 'lodash/find'
// import Resource from '../../../../resources'
import myUtil from './util'

const MAX_POINTS = 100 // 缩放移动地图时最多显示的点数
const DEFAULT_ZOOM_SCALE = 16 // 默认缩放等级
const MAX_POINTS_INITIAL_LOAD = 10

const MARKER_CLASS_DEFAULT = 'smart_map_marker_default'
const MARKER_CLASS_SELECTED = 'smart_map_marker_selected'

export default {
  props: {
    userAgent: {
      type: Boolean,
      default: false
    },
    markers: {
      type: Array
    },
    mapDomId: {
      type: String,
      default: 'yqz-smart-map'
    },
    enableResize: {
      // 是否允许全屏
      type: Boolean,
      default: true
    },
    draggable: {
      type: Boolean,
      default: true
    },
    enableScale: {
      // 是否开启缩放组件
      type: Boolean,
      default: false
    },
    initMarkerId: {
      // 初始化选中的点
      type: Number
    },
    initMode: {
      type: String
    },
    initZoom: {
      // 初始化缩放比例
      type: Number,
      default: 0
    },
    collapseHeight: {
      // 高度
      type: Number,
      default: 200
    },
    expandHeight: {
      // 全屏高度
      type: Number,
      default: 500
    },
    perLocation: {
      // 初始化时,定位地图中心点的参照点
      type: Object
    }
  },

  data() {
    return {
      mode: this.initMode || 'collapse',
      mapDom: {},
      smartMap: {},
      resizeControl: undefined,
      visibleMarkers: [],
      idListOfLoadedMarkers: {},
      selectedMarker: undefined,
      isClick: true, // 气泡点击时间开关
      touchStartNum: 0 // 触摸开始
    }
  },

  computed: {
    mapHeight() {
      return this.mode === 'collapse' ? this.collapseHeight : this.expandHeight
    }
  },

  watch: {
    initMode() {
      const vm = this
      if (this.initMode === 'collapse' || this.initMode === 'expand') {
        vm.mode = vm.initMode
      }
      if (vm.setMode) {
        vm.setMode(vm.mode)
      }
    },
    visibleMarkers(newMarkers) {
      const vm = this
      Object.keys(newMarkers).forEach((key) => {
        vm.addMarkerToMap(newMarkers[key])
      })
    }
  },
  mounted, // 用mounted确保dom元素已经加载
  methods: {
    initMap,
    onMapLoaded,
    setupResizeControl,
    refreshMap,
    addMarkerToMap,
    initMapEventListener,
    setMode,
    getMapContex,
    selectMarker,
    clearCurrentSelection,
    reset
  }
}

function getMapContex() {
  const vm = this
  return {
    expand() {
      if (vm.mode === 'expand') return
      vm.setMode('expand')
    },
    collapse() {
      if (vm.mode === 'collapse') return
      vm.setMode('collapse')
    },
    moveTo({ markerId }) {
      const theMarker = find(vm.markers, { markerId })
      if (theMarker) {
        vm.selectMarker(markerId)
        vm.refreshMap(MAX_POINTS)
      }
    },
    reset() {
      vm.reset()
    }
  }
}
async function mounted() {
  const vm = this
  myUtil.loadScript(() => {
    vm.initMap()
    vm.$emit('get-map-context', vm.getMapContex())
  }, vm.userAgent)
}

async function initMap() {
  console.log('[yqz] start initializing qq map')
  const vm = this
  vm.mapDom = document.getElementById(vm.mapDomId)

  // 确定初始中心点
  vm.initCenter = await myUtil.determinInitialCenter({
    markers: vm.markers,
    initMarkerId: vm.initMarkerId,
    perLocation: vm.perLocation,
    $store: vm.$store
  })
  // 创建地图实例
  vm.smartMap = new qq.maps.Map(vm.mapDom, {
    minZoom: 3, // 此处设置地图的缩放级别 最小值是6
    maxZoom: 18,
    draggable: this.draggable,
    zoom: vm.initZoom ? vm.initZoom : DEFAULT_ZOOM_SCALE, // 设置地图缩放级别
    zoomControl: this.enableScale, // 启用缩放控件
    panControl: false, // 移除左上角的控制盘
    mapTypeControlOptions: {
      // 设置控件的地图类型为普通街道地图
      mapTypeIds: qq.maps.MapTypeId.ROADMAP
    },
    center: new qq.maps.LatLng(vm.initCenter.latitude, vm.initCenter.longitude)
  })
  // 监听地图缩放事件
  vm.initMapEventListener()

  // 如果地图在平移或缩放之后变为闲置状态，则会触发此事件
  // 这里实际上用于地图首次加载后的处理, 在onLoad内部
  // 会将idle的监听, 重置监听
  qq.maps.event.addListener(vm.smartMap, 'idle', vm.onMapLoaded)
}

function onMapLoaded() {
  const vm = this
  // console.log("map loaded");
  vm.setupResizeControl()
  const count = vm.refreshMap(MAX_POINTS_INITIAL_LOAD)

  if (!vm.initZoom) {
    // 如果没有设置初始化zoom值, 且是首次加载则进行自动缩放
    if (count < MAX_POINTS_INITIAL_LOAD && count < vm.markers.length) {
      // 如果加载点数不够MAX_POINTS_INITIAL_LOAD,则继续zoom
      setTimeout(() => {
        vm.smartMap.zoomBy(-2)
      }, 0)
    } else {
      resetIdleListner()
    }
  } else {
    resetIdleListner()
  }

  function resetIdleListner() {
    if (vm.initMarkerId) {
      vm.selectMarker(vm.initMarkerId)
    }
    qq.maps.event.clearListeners(vm.smartMap, 'idle')
    qq.maps.event.addListener(vm.smartMap, 'idle', () => {
      vm.refreshMap(MAX_POINTS)
    })
  }
}

function setupResizeControl() {
  const vm = this
  if (!vm.enableResize) return

  if (vm.resizeControl) return

  vm.resizeControl = document.createElement('img')
  vm.resizeControl.style.cssText = 'width:55px;height:55px:'
  vm.resizeControl.setMapMode = setMapMode
  vm.resizeControl.onclick = onclick

  vm.smartMap.controls[qq.maps.ControlPosition.TOP_RIGHT].push(vm.resizeControl)

  vm.resizeControl.setMapMode(vm.mode)

  function setMapMode(mode) {
    /* eslint-disable */
    let icon = {
      // collapse: Resource.mapIcon.mapIconExpand,
      collapse: '',
      // expand: Resource.mapIcon.mapIconCollapse,
      expand: '',
    };
    /* eslint-enable */
    vm.mode = mode
    this.src = icon[mode]
  }

  function onclick() {
    const newMode = vm.mode === 'expand' ? 'collapse' : 'expand'
    this.setMapMode(newMode)
    vm.$emit('map-resized', { mode: newMode })
  }
}

function refreshMap(maxPoints) {
  let count = 0
  const mapBounds = this.smartMap.getBounds()
  const visibleMarkers = []

  // 检查一个点是否在一个区域中latLngBounds.contains();
  for (let i = 0; i < this.markers.length; i += 1) {
    const marker = this.markers[i]
    if (
      mapBounds.contains(new qq.maps.LatLng(marker.latitude, marker.longitude))
    ) {
      visibleMarkers.push(marker)
      count += 1
      if (count >= maxPoints) break
    }
  }
  this.visibleMarkers = visibleMarkers
  // console.log(`refresh map with ${count} markers`);
  return count
}

function reset() {
  const vm = this
  vm.clearCurrentSelection()
  vm.smartMap.panTo(
    new qq.maps.LatLng(this.initCenter.latitude, this.initCenter.longitude)
  )
}

function clearCurrentSelection() {
  const vm = this
  if (vm.selectedMarker) {
    // 将前一次点击的高亮显示清除
    vm.selectedMarker.mapLabel.setContent(
      vm.selectedMarker.mapLabel.content.replace(
        MARKER_CLASS_SELECTED,
        MARKER_CLASS_DEFAULT
      )
    )
    vm.selectedMarker.mapLabel.setZIndex(99)
  }
}

function selectMarker(markerId) {
  const vm = this
  vm.clearCurrentSelection()

  const theMarker = find(vm.markers, { markerId })
  vm.addMarkerToMap(theMarker)
  if (theMarker) {
    theMarker.mapLabel.setContent(
      theMarker.mapLabel.content.replace(
        MARKER_CLASS_DEFAULT,
        MARKER_CLASS_SELECTED
      )
    )
    theMarker.mapLabel.setZIndex(999) // 置顶

    // 移到地图中心位置
    vm.smartMap.panTo(
      new qq.maps.LatLng(theMarker.latitude, theMarker.longitude)
    )
    vm.selectedMarker = theMarker
    // 放大级别 ...
    // vm.smartMap.zoomBy(2);
    vm.$emit('marker-click', theMarker)
  }
}

function addMarkerToMap(theMarker) {
  const vm = this

  // 如果已经添加过,则不再添加
  if (vm.idListOfLoadedMarkers[theMarker.markerId]) {
    return
  }
  // 标记该点已经添加,避免重复添加
  vm.idListOfLoadedMarkers[theMarker.markerId] = true

  const labelInfo = myUtil.createLabel(theMarker, MARKER_CLASS_DEFAULT)
  const mapLabel = new qq.maps.Label({
    offset: new qq.maps.Size(labelInfo.X_Point, labelInfo.Y_Point),
    position: new qq.maps.LatLng(theMarker.latitude, theMarker.longitude),
    map: vm.smartMap,
    visible: true,
    content: labelInfo.content // 标记显示的内容
  })
  mapLabel.setStyle({ background: '', border: '' })

  theMarker.mapLabel = mapLabel; /* eslint-disable-line */

  bindLabelOnClickFunc(mapLabel) // 气泡点击事件

  function bindLabelOnClickFunc(label) {
    // 切换到小地图模式
    qq.maps.event.addListener(label, 'click', onLabelClick)

    function onLabelClick() {
      // 获取标记的点击事件
      if (vm.isClick) {
        // 标记选中状态先
        // label.markSelect();
        // vm.$emit("marker-click", theMarker);
        vm.selectMarker(theMarker.markerId)
      }
    }
  }
}

/**
 *  监听地图缩放事件
 */
function initMapEventListener() {
  const vm = this
  vm.mapDom.addEventListener(
    'touchstart',
    (event) => {
      vm.touchStartNum = Number(
        event.changedTouches[0].pageX + event.changedTouches[0].pageY
      )
    },
    false
  )
  vm.mapDom.addEventListener(
    'touchmove',
    (event) => {
      const touchMoveNum = Number(
        event.changedTouches[0].pageX + event.changedTouches[0].pageY
      )
      const offsetXY = vm.touchStartNum - touchMoveNum
      if (event.changedTouches.length !== 1) {
        // 多指触摸
        vm.isClick = false
      } else if (offsetXY !== 0) {
        // 当滑动时关闭开关
        vm.isClick = false
      }
    },
    false
  )
  // 监听手势触摸结束（手指抬起来）事件
  vm.mapDom.addEventListener(
    'touchend',
    () => {
      // 当手指从地图上抬起来时，将地图上点击lab事件打开
      // 设置一个定时器将开关打开，防止误触碰多个事件时，开关延时500毫秒打开
      setTimeout(() => {
        vm.isClick = true
      }, 300)
    },
    false
  )
}

function setMode(mode) {
  if (this.resizeControl && this.resizeControl.setMapMode) {
    this.resizeControl.setMapMode(mode)
  }
}
</script>
<template>
  <div>
    <div :id="mapDomId" :style="{ height: mapHeight + 'px' }"></div>
  </div>
</template>
<style>
/* 个数样式 */
.smart_map_sub_title {
  /*color: #FBD5C7;*/
}

.smart_map_marker_default {
  color: #ffffff;
  border-radius: 5px;
  padding: 8px 10px;
  /*font-weight: 500;*/
  text-align: left;
  font-size: 13px;
  line-height: 13px;
  float: left;
  position: relative;
  border: 1px solid #009ead;
  background: #00bfd1;
  box-sizing: border-box;
  box-shadow: 0 1px 3px RGBA(0, 0, 0, 0.3);
  letter-spacing: 1.5px;
}

.smart_map_marker_selected {
  color: #ffffff;
  border-radius: 5px;
  padding: 8px 10px;
  font-weight: 500;
  text-align: left;
  font-size: 13px;
  line-height: 13px;
  float: left;
  position: relative;
  border: 1px solid #db4f18;
  background: #fe733d;
  box-sizing: border-box;
  box-shadow: 0 1px 3px RGBA(0, 0, 0, 0.3);
  letter-spacing: 1.5px;
}

:deep(.smart_map_marker_default:before) {
  position: absolute;
  content: '';
  width: 6px;
  height: 6px;
  bottom: -8px;
  left: 50%;
  top: 89%;
  margin-left: -7px;
  overflow: hidden;
  pointer-events: none;
  -webkit-transform: rotate(45deg);
  -mz-transform: rotate(45deg);
  transform: rotate(45deg);
  background: #00bfd1;
  /*background-color: rgb(242, 118, 75,0.5);*/
  box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
  border-right: 1px solid #00bfd1;
  border-bottom: 1px solid #00bfd1;
}

:deep(.smart_map_marker_selected:before) {
  position: absolute;
  content: '';
  width: 6px;
  height: 6px;
  bottom: -8px;
  left: 50%;
  top: 89%;
  margin-left: -7px;
  overflow: hidden;
  pointer-events: none;
  -webkit-transform: rotate(45deg);
  -mz-transform: rotate(45deg);
  transform: rotate(45deg);
  background: #fe733d;
  box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
  border-right: 1px solid #fe733d;
  border-bottom: 1px solid #fe733d;
}
</style>
